<script>
export default {
  install(Vue) {
    const HashUtil = function () {

      const SEPARATOR = ",";

      const add = (hash) => {
        let newHash = window.location.hash || "";
        if (newHash.indexOf(hash) !== -1) {
          return;
        }
        if (newHash.startsWith("#")) {
          newHash = newHash.substring(1);
        }
        if (newHash.length > 0) {
          newHash += SEPARATOR;
        }
        newHash += hash;
        let newUrl = window.location.pathname;
        if (newHash.length > 0) {
          newUrl += "#" + newHash;
        }
        history.pushState(null, null, newUrl);
        window.dispatchEvent(new Event("hashchange"));
      }

      const remove = (hash) => {
        let newHash = window.location.hash || "";
        if (newHash.indexOf(hash) === -1) {
          return;
        }
        if (newHash.startsWith("#")) {
          newHash = newHash.substring(1);
        }
        const split = newHash.split(SEPARATOR);
        while (split.indexOf(hash) !== -1) {
          split.splice(split.indexOf(hash), 1);
        }
        newHash = split.join(SEPARATOR);
        let newUrl = window.location.pathname;
        if (newHash.length > 0) {
          newUrl += "#" + newHash;
        }
        history.pushState(null, null, newUrl);
        window.dispatchEvent(new Event("hashchange"));
      }

      const contains = (hash) => {
        let newHash = window.location.hash || "";
        if (newHash.indexOf(hash) === -1) {
          return false;
        }
        if (newHash.startsWith("#")) {
          newHash = newHash.substring(1);
        }
        const split = newHash.split(SEPARATOR);
        return split.indexOf(hash) !== -1;
      }

      const getAll = () => {
        let newHash = window.location.hash || "";
        if (newHash.startsWith("#")) {
          newHash = newHash.substring(1);
        }
        return newHash.split(SEPARATOR);
      }

      return {
        add,
        remove,
        contains,
        getAll
      };
    };
    Vue.$hashUtil = new HashUtil()
  }
}
</script>